<template>
  <div class>
    <div
      v-for="(section, section_key) in bookSections"
      :key="section_key"
      class="book-section-area"
    >
      <ul>
        <li class="state-disabled section-inner first section-title" :id="section.clip_type.slug">
          <h4>
            <span class="haggadah-section-title text-uppercase">{{ section.clip_type.name }}</span>
            <a
              class="pull-right add-clip-content"
              @click.prevent="activateCurrentSction(section.id)"
            >
              <span class="txt">ADD {{ trans('clip.Singular') }}</span>
              <img src="/themes/front/img/icon/add-clip-post.png" alt="Add Clip" />
            </a>
          </h4>
        </li>
      </ul>
      <ul class="clip_list connectedSortable" :data-section="section.id">
        <clip-list
          :book-id="bookId"
          :current-user="currentUser"
          :section-key="section.id"
          :section-name="section.clip_type.name"
          :book-sections="bookSectionList"
          :clip_type_id="section.clip_type_id"
          :search-suggestions-setting="searchSuggestionsSetting"
          ref="clipList"
          @updateDrag="updateDrag"
        ></clip-list>
        <li class="clip-movable state-disabled insert-clip-section last text-uppercase">
          <a
            class="btn btn-square insert-clip add-clip-btn"
            @click.prevent="activateCurrentSction(section.id)"
          >
            INSERT {{ trans('clip.singular') }}
            <i class="fa fa-plus"></i>
          </a>
        </li>
      </ul>
      <!-- use the modal component, pass in the prop -->
      <clip-insert
        v-if="openInsertSection(section.id)"
        :book-sections="section.clip_type.id"
        :book-id="bookId"
        :book-details="bookDetails"
        :section="section.clip_type.name"
        :section-key="section.id"
        loader="show"
        v-bind:exist-clips="allClipList"
        @close="clipInsert = false"
        @completed="insertClip"
      ></clip-insert>
    </div>
    <div class="ajax-loader" :class="setLoadingClass()">
      <div>
        <i class="fa fa-spinner fa-pulse fa-5x fa-fw ajax-overlay"></i>
      </div>
    </div>
  </div>
</template>

<script>
Vue.component("clip-list", require("../components/ClipList.vue"));
Vue.component("clip-insert", require("../components/ClipInsert.vue"));
import { mapMutations } from "vuex";

export default {
  props: [
    "bookId",
    "bookDetails",
    "storedClipList",
    "currentUser",
    "bookSections",
    "searchSuggestionsSetting",
  ],
  data() {
    return {
      clipInsert: false,
      activeSection: "",
      bookSectionList: {},
      dragabble: {
        current_clip_slug: "",
        current_clip_section: "",
        current_clip_position: ""
      }
    };
  },
  computed: {
    allClipList: {
      get() {
        return this.$store.state.savedClipList;
      },
      set(value) {
        // console.log('set method');
        //  this.$store.commit('getClipList', value);
      }
    },
    sectionsWiseClips: function() {
      return this.$store.state.sectionsWiseClips;
    },
    existingClips: function() {
      return $.map(this.allClipList, function(clip) {
        return clip.id;
      });
    }
  },
  mounted: function() {
    this.getSectionList();
    if ("section_id_book_slider" in localStorage) {
        this.activateCurrentSction(localStorage.getItem("section_id_book_slider"));

      // Remove local storage variable section_id_book_slider setted from book preview page at end of each book section
      localStorage.removeItem("section_id_book_slider");
    }
  },

  methods: {
    slug(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "");
    },
    activateCurrentSction(section_key) {
      var vm = this;
      vm.clipInsert = true;
      vm.activeSection = section_key;
      // openInsertSection(section_key);
    },
    openInsertSection(section_key) {
      var vm = this;
      if (vm.activeSection == section_key && vm.clipInsert === true) {
        return true;
      }
      return false;
    },
    insertClip(data) {
      var vm = this; //declare this
      var clip_list = data.result;
      var section_id = data.section_id;
      this.$store.commit("getClipList", { data:clip_list});
      this.clipInsert = false;
    },
    updateDrag(data) {
      // console.log('bookinsertclipsection');
      if (data.hasOwnProperty("current_clip_slug")) {
        this.dragabble["current_clip_slug"] = data.current_clip_slug;
      }
      if (data.hasOwnProperty("current_clip_section")) {
        this.dragabble["current_clip_section"] = data.current_clip_section;
      }
      if (data.hasOwnProperty("current_clip_position")) {
        this.dragabble["current_clip_position"] = data.current_clip_position;
      }
    },
    setLoadingClass() {
      if (this.$store.state.is_loading) {
        return "show";
      }
      return ["hide", this.setSectionActive()];
    },
    setSectionActive()
    {
      // checking '?' query string url from edit_show_confirmation model.
      var uri = window.location.toString();
      if (uri.indexOf("?") <= 0) {
        if (location.hash) {
          var currentUrl = window.location.pathname + location.hash;
          window.location = currentUrl;
        }
      }
    },
    getSectionList() {
      var vm = this;
      vm.bookSectionList = {};
      for(var section_details of vm.bookSections) {
        vm.bookSectionList[`${section_details['id']}`] = section_details['clip_type']['name'];
      }
    }
  }
};
</script>